import React from "react";
import { 
  Box, 
  Container, 
  Typography, 
  Link, 
} from "@mui/material";
import { useTranslation } from 'react-i18next';
import info from "app-info";

function Footer() {
  const { t } = useTranslation();

  return (
    <Box component="footer" sx={{ position: 'relative', bgcolor: '#e2e8f0', pt: 8, pb: 6 }}>
      {/* Elemento SVG decorativo (Polygon Top) */}
      <Box 
        sx={{
          top: 0,
          left: 0,
          right: 0,
          width: '100%',
          position: 'absolute',
          pointerEvents: 'none',
          overflow: 'hidden',
          height: '80px',
          mt: '-80px',
          transform: 'translateZ(0)'
        }}
      >
        <svg
          style={{ position: 'absolute', bottom: 0, overflow: 'hidden' }}
          xmlns="http://www.w3.org/2000/svg"
          preserveAspectRatio="none"
          version="1.1"
          viewBox="0 0 2560 100"
          x="0"
          y="0"
        >
          <polygon
            style={{ fill: '#e2e8f0' }}
            points="2560 0 2560 100 0 100"
          ></polygon>
        </svg>
      </Box>

      <Container maxWidth="lg">
         <Box 
          sx={{ 
            display: 'flex', 
            flexWrap: 'wrap', 
            alignItems: 'center', 
            justifyContent: 'center' 
          }}
        >
          <Typography variant="body2" sx={{ color: 'text.secondary', fontWeight: 500 }}>
            Copyright © {new Date().getFullYear()} {info.title} by{" "}
            <Link 
              href="https://www.crimerate.it/" 
              target="_blank" 
              underline="hover"
              sx={{ color: 'inherit' }}
            >
              Alex Corti (CRI Merate)
            </Link>
          </Typography>
        </Box>
      </Container>
    </Box>
  );
}

export default Footer;